import { render } from "./AmountRequest.vue?vue&type=template&id=96fd8f9a&ts=true"
import script from "./AmountRequest.vue?vue&type=script&lang=ts"
export * from "./AmountRequest.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__